import { graphql, useFragment } from 'react-relay';

import { type useAppliedFilterUrlLabel_itemSearch$key } from './__generated__/useAppliedFilterUrlLabel_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment useAppliedFilterUrlLabel_itemSearch on ItemSearchQueryConnection {
        appliedFilters {
            name
            values {
                urlLabel
            }
        }
    }
`;

export const useAppliedFilterUrlLabel = (
    itemSearchRef: useAppliedFilterUrlLabel_itemSearch$key,
    filterName: string
): string | null => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        (itemSearch.appliedFilters || []).find(filter => filter?.name === filterName)?.values?.[0]
            ?.urlLabel || null
    );
};
